import { render, staticRenderFns } from "./reserveRecordDetails.vue?vue&type=template&id=40c7f5a4&scoped=true&"
import script from "./reserveRecordDetails.vue?vue&type=script&lang=js&"
export * from "./reserveRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./reserveRecordDetails.vue?vue&type=style&index=0&id=40c7f5a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c7f5a4",
  null
  
)

export default component.exports